import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  initialize = () => {
    const height = this.element.getBoundingClientRect().top
    this.element.style.height = `${window.innerHeight - height}px`
  }
}
